/**
 * 위치정보 이용 안내 (Location Information) - 한국어 v2
 * 
 * 시행일: 2026년 2월 1일
 */
export const LOCATION_V2_KO = {
    version: "v2",
    effectiveDate: "2026-02-01",
    language: "ko",
    title: "위치정보 이용 안내",
    content: `
위치정보 이용 안내

최종 업데이트: 2026년 2월 1일 (KST)

Spot Go("서비스")는 「위치정보의 보호 및 이용 등에 관한 법률」에 따라 개인위치정보를 수집·이용합니다.

1. 위치정보 수집자

서비스명: Spot Go
연락처: lukep81@painori.com

2. 수집하는 위치정보 항목

• GPS 기반 실시간 위치정보 (위도, 경도)
• WiFi/기지국 기반 대략적 위치정보

3. 위치정보의 이용 목적

• 주변 스팟(매장/게시물) 검색
• 위치 기반 콘텐츠 표시
• 스팟 등록 시 위치 자동 입력
• 지도 서비스 제공 (국내: 네이버 지도 / 해외: Leaflet/OpenStreetMap)

4. 위치정보의 보유 및 이용 기간

• 실시간 위치: 서비스 이용 중에만 활용되며, 서버에 저장되지 않습니다.
• 스팟 등록 위치: 해당 게시물과 함께 보관됩니다.
• 계정 탈퇴 시: 모든 위치 관련 데이터가 삭제됩니다.

5. 위치정보의 제3자 제공

원칙적으로 제3자에게 제공하지 않습니다.

예외:
• 법령에 의해 요구되는 경우
• 지도 서비스 제공을 위한 외부 API 호출 시 (네이버, Leaflet/OpenStreetMap)

6. 이용자의 권리

• 위치정보 수집·이용 동의를 언제든지 철회할 수 있습니다.
• 동의 철회 시 위치 기반 서비스 이용이 제한됩니다.
• 문의: lukep81@painori.com

7. 동의하지 않을 경우

⚠️ 중요 안내

Spot Go는 위치기반 서비스입니다. 위치정보 수집에 동의하지 않으시면 로그인이 불가하며, 모든 콘텐츠 이용이 제한됩니다.

서비스 이용을 위해서는 위치정보 수집·이용에 동의해 주셔야 합니다.
`.trim()
};
